import statusLabel from './statusLabel'

const priceTables = {
  statusLabel,
}

export default priceTables
